import { render } from "./print-labels-modal.vue?vue&type=template&id=a782b3c2"
import script from "./print-labels-modal.vue?vue&type=script&lang=js"
export * from "./print-labels-modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__